import React from 'react';

// Modern Geometric Logo with Tech Elements
const LogoOption1 = ({ className = "" }) => {
  return (
    <svg
      viewBox="0 0 200 200"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="logo1Gradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{ stopColor: '#10b981', stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: '#059669', stopOpacity: 1 }} />
        </linearGradient>
      </defs>
      
      {/* Hexagonal background */}
      <path
        d="M 100 10 L 170 50 L 170 130 L 100 170 L 30 130 L 30 50 Z"
        fill="url(#logo1Gradient)"
      />
      
      {/* Inner hexagon border */}
      <path
        d="M 100 30 L 150 55 L 150 115 L 100 140 L 50 115 L 50 55 Z"
        fill="none"
        stroke="white"
        strokeWidth="2"
        opacity="0.3"
      />
      
      {/* TYJ Letters */}
      <text
        x="100"
        y="115"
        fontFamily="Arial, sans-serif"
        fontSize="55"
        fontWeight="bold"
        fill="white"
        textAnchor="middle"
        dominantBaseline="middle"
      >
        TYJ
      </text>
      
      {/* Tech dots */}
      <circle cx="100" cy="40" r="3" fill="white" opacity="0.8" />
      <circle cx="140" cy="70" r="3" fill="white" opacity="0.8" />
      <circle cx="60" cy="70" r="3" fill="white" opacity="0.8" />
    </svg>
  );
};

export default LogoOption1;